import React from 'react';
import PhoneInput from 'react-phone-input-2';
import IconButton from '@mui/material/IconButton';
import ProfileCustomClearIcon from '../../../HelperIcons/ProfileCustomClearIcon';
import ProfileCustomDeleteIcon from '../../../HelperIcons/ProfileCustomDeleteIcon';
import 'react-phone-input-2/lib/style.css';
import './customPhoneInput.css'; // Import the custom CSS file
import { Box, Stack } from '@mui/material';
import { isPossiblePhoneNumber } from 'libphonenumber-js';


const handlePhoneChange = (val, country, e, formattedVal, index, onChange) => {
  const transientEvt = {
    target: {
      value: `+${val}`,
    },
  };
   if (typeof onChange === 'function') {
    onChange(index, transientEvt);
  }
};


const validatePhoneNumber = (inputNumber, field) => {
    if (field.isPristine) return true;
    const isValid =  isPossiblePhoneNumber(`+${inputNumber}`);
    field.isInvalid = !isValid;
    return isValid;
}

const CustomPhoneInput = ({
  index,
  field,
  onChange,
  onClear,
  onDelete,
  shudClearBtnRender,
  shudDeleteBtnRender,
}) => {
  return (
    <Stack direction="row" alignItems="center" width="100%" padding="10px 0" sx={{ borderBottom: '1px solid #E7E7FF' }}>
      <Box flexGrow={1} width="100%">
        <PhoneInput
          country={'us'}
          autoFormat={false}
          placeholder="Enter country code followed by phone number"
          value={field.value}
          onChange={(val, cn, e, formattedVal) => handlePhoneChange(val, cn, e, formattedVal, index, onChange)}
          disabled={field.disabled}
          inputStyle={{ width: '100%', border: 'none', outline: 'none', fontFamily: 'Figtree-Regular, sans-serif' }}
          containerStyle={{ width: '100%', borderBottom: 'none' }}
          dropdownClass="custom-dropdown"
          isValid={(inputNumber, country, countries, hiddenAreaCode) => {
            return validatePhoneNumber(inputNumber, country, countries, hiddenAreaCode, field);
          }}
          defaultErrorMessage="Phone number is invalid."
        />
      </Box>
      <Stack direction="row" spacing={1} marginRight="22px">
        {shudClearBtnRender && (
          <IconButton
            aria-label="clear"
            onClick={(e) => onClear(index, e)}
            disabled={field.disabled}
            edge="end"
          >
            <ProfileCustomClearIcon
              sx={{
                backgroundColor: field.disabled ? 'transparent' : 'lightgrey',
                color: 'white',
                borderRadius: '50%',
                width: '18px',
                height: '18px',
              }}
            />
          </IconButton>
        )}
        {shudDeleteBtnRender && (
          <IconButton
            aria-label="delete"
            onClick={(e) => onDelete(index, e)}
            disabled={field.disabled}
            edge="end"
          >
            <ProfileCustomDeleteIcon
              sx={{
                width: '20px',
                height: '20px',
              }}
              color={field.disabled ? 'transparent' : '#F74646'}
            />
          </IconButton>
        )}
      </Stack>
    </Stack>
  );
};

export default CustomPhoneInput;
